exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2jQD9 {\n  margin-top: 0 !important;\n  padding-top: 0 !important;\n}\n", ""]);

// Exports
exports.locals = {
	"list": "_2jQD9"
};